import { CardStack } from '../card-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { Orientation } from '../../../../enum/dto/orientation.enum';

export abstract class FiveByFiveCardStack extends CardStack {
  getCardHeightInInches(): number {
    return 5;
  }

  getCardWidthInInches(): number {
    return 5;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 2;
  }

  nColumns(): number {
    return 1;
  }

  nRows(): number {
    return 2;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Landscape;
  }
}
